import { motion } from "motion/react";
import { Users, TrendingUp, ShieldCheck, Target } from "lucide-react";

export function WhoWeHelp() {
  const cards = [
    {
      icon: <Users className="w-8 h-8 text-[#FD5750]" />,
      title: "SMEs & Startups",
      description: "Growing businesses looking to scale their digital infrastructure without hiring a massive in-house team.",
    },
    {
      icon: <Target className="w-8 h-8 text-[#FD5750]" />,
      title: "Visionary Founders",
      description: "Leaders who need a technical partner to translate their complex business ideas into functional products.",
    },
    {
      icon: <ShieldCheck className="w-8 h-8 text-[#FD5750]" />,
      title: "Enterprises",
      description: "Established companies needing specialized consultation for security, UX, or digital transformation.",
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4">
            Who We Empower
          </h2>
          <p className="text-slate-600 text-lg">
            We specialize in briding the gap between business goals and technology for Startups & Enterprises.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {cards.map((card, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              viewport={{ once: true }}
              className="p-8 rounded-2xl bg-slate-50 border border-slate-100 hover:shadow-lg hover:border-[#FD5750]/30 transition-all duration-300 group"
            >
              <div className="mb-6 p-4 bg-white rounded-xl inline-block shadow-sm group-hover:scale-110 transition-transform duration-300">
                {card.icon}
              </div>
              <h3 className="text-xl font-bold text-slate-900 mb-3">{card.title}</h3>
              <p className="text-slate-600 leading-relaxed">
                {card.description}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
